import React from 'react'
import { connect } from 'react-redux'
import { getDeliveryReceiptLabelAction } from '../../../../actions/appActions'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'

class Component extends React.Component {
    state = { open: false, loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
        this.confirm()
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false })
    }

    confirm = () => {
        this.setState({ loading: true })
        this.props
            .getDeliveryReceiptLabelAction(this.props.orderId, false)
            .then(() => this.handleClose(true))
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.downloadDeliveryReceipt}
                </div>

                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

const mapDispatchToProps = { getDeliveryReceiptLabelAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)